import React, { useEffect, useState } from "react";
import { FilterProperties } from "../../Models/FilterProperties";
import { SortByObj } from "../../Models/SortByObj";


const SortByDescAndTemplate: React.FunctionComponent<{ filterOptionsValue: any, OnSelectChangeSortBy: any, thead: string }> = (props) => {

    const [filterOptions, setFilterOptions] = useState<SortByObj>(props.filterOptionsValue);

    useEffect(() => {
        setFilterOptions(props.filterOptionsValue)
    })

    const handleSelectSortBy = () => {
        setFilterOptions((prevState: any) => {
            const newState = {
                ...prevState,
                sortBy: props.thead,
                low_to_high: !prevState.low_to_high,
            };
            props.OnSelectChangeSortBy(newState);
            return newState;
        });
    };

    return (
        <button
            className="border-trans back-trans "
            type="button"
            onClick={handleSelectSortBy}
        >
            {filterOptions.low_to_high ? (
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1117_1711)">
                        <path d="M4.30615 6L8.30615 10L12.3062 6" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1117_1711">
                            <rect width="16" height="16" fill="white" transform="matrix(1 0 0 -1 0.306152 16)" />
                        </clipPath>
                    </defs>
                </svg>
            ) : (
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1117_1711)">
                        <path d="M4.30615 6L8.30615 10L12.3062 6" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1117_1711">
                            <rect width="16" height="16" fill="white" transform="matrix(1 0 0 -1 0.306152 16)" />
                        </clipPath>
                    </defs>
                </svg>


            )}
        </button>

    );
};

export default SortByDescAndTemplate;
